import React from 'react';
import PropTypes from 'prop-types';
import { color } from '../../../styles/theme';

const Carot = ({ className, selected, strokeColor = color.primary }) => (
  <div className={className}>
    <svg width="18" height="11" xmlns="http://www.w3.org/2000/svg">
      <polyline
        fill="none"
        stroke={!selected ? strokeColor : color.textLight}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        points="1261 4377 1268 4370 1275 4377"
        transform="rotate(-180 638.5 2189.5)"
      />
    </svg>
  </div>
);

Carot.propTypes = {
  className: PropTypes.string,
  strokeColor: PropTypes.string,
  selected: PropTypes.bool
};

export default Carot;
